import React from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import { ScrollText } from "./common/Icons";

const QatarHero = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="position-relative">
        <div className="position-absolute hero_scroll_text">
          <ScrollText />
        </div>
        <div id="react-player-value" className="position-relative">
          <ReactPlayer
            className="react-player"
            url="https://vz-e28eac45-f0a.b-cdn.net/fdff9e5a-abf2-4f76-a1f4-879709100343/playlist.m3u8"
            width="100%"
            playing={true}
            loop={true}
            muted={true}
            height="100%"
          />
        </div>
        <div
          className="position-absolute bottom-0 w-100 h-100 d-flex
            justify-content-sm-end justify-content-center flex-column"
        >
          <div className="pb-sm-5 mb-sm-5 container">
            <h2
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-delay="200"
              className="text-white text-sm-start text-center font-2xl fw-lighter ff_josfin"
              onClick={() => navigate("/contact")}
            >
              QATAR NATIONAL VISION 2030
            </h2>
            <p
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-delay="600"
              className="text-white text-sm-start text-center font-lg fw-light opactiy_8"
            >
              Cyboryx Aligning With Our Land’s Vision
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default QatarHero;
